module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/86.6ad3aea2.png";